<script lang="ts">
    import { Col } from "sveltestrap";
    import { Dropfileshereorclicktoupload, Note, Remove, SingleFileUpload } from "../../../utils/Constant/Constant";
    import Card from "../../Core/Card.svelte";
    import Dropzone from "svelte-file-dropzone";
    let files = {
      accepted: [],
      rejected: []
    };

  function handleFilesSelect(e:any) {
    const { acceptedFiles, fileRejections } = e.detail;
    files.accepted = [...files.accepted, ...acceptedFiles];
    files.rejected = [...files.rejected, ...fileRejections];
  }
  function handleRemoveFile(e:any, index:number) {
    files.accepted.splice(index, 1);
    files.accepted = [...files.accepted];
  }

</script>
<Col sm="12">
    <Card cardHeaderprops="pb-0" headerTitle={SingleFileUpload} >
      <div slot="contentbody">
        <Dropzone on:drop={handleFilesSelect} multiple={false} >
            <h6>{Dropfileshereorclicktoupload}</h6>
            <span class="note needsclick">{@html Note}</span>
        </Dropzone>
        <ol>
          {#each files.accepted as filesItem,index}
            <li>{filesItem.name}</li>
            <button on:click={e => handleRemoveFile(e, index)}>{Remove}</button>
          {/each}
        </ol>
      </div>
    </Card>
</Col>